import { AfterContentInit, Component, Directive, Input, Output, EventEmitter, ContentChildren, QueryList } from "@angular/core";

// content slots

// slot / icon
@Directive({
  selector: 'summary-card-icon'
})
export class SummaryCardIconDirective {}

// slot / header
@Directive({
  selector: 'summary-card-header'
})
export class SummaryCardHeaderDirective {}

// slot / body content
@Directive({
  selector: 'summary-card-body'
})
export class SummaryCardBodyDirective {}

// slot / flags
@Directive({
  selector: '[summary-card-flag]',
  host: {
    class: 'flag'
  }
})
export class SummaryCardFlagDirective {}

@Directive({
  selector: 'summary-card-flags'
})
export class SummaryCardFlagsDirective implements AfterContentInit {
  @ContentChildren(SummaryCardFlagDirective)
  childrenContent?: QueryList<SummaryCardFlagDirective>;

  public hasChildren: boolean = false;

  ngAfterContentInit() {
    this.hasChildren = !!this.childrenContent?.length;
  }
}

// slot / action
@Directive({
  selector: '[summary-card-action]'
})
export class SummaryCardActionDirective {}

@Directive({
  selector: 'summary-card-actions'
})
export class SummaryCardActionsDirective {
  @ContentChildren(SummaryCardActionDirective)
  childrenContent?: QueryList<SummaryCardActionDirective>;

  public hasChildren: boolean = false;

  ngAfterContentInit() {
    this.hasChildren = !!this.childrenContent?.length;
  }
}


// component
@Component({
  selector: 'spark-summary-card',
  styleUrls: ['./summary-card.component.scss'],
  templateUrl: './summary-card.component.html',
})
export class SummaryCardComponent {
  @Input()
  link: any[] = [];

  @Input()
  isClickable: boolean = false;

  @Output()
  onClick: EventEmitter<Event> = new EventEmitter<Event>();

  @ContentChildren(SummaryCardIconDirective, { descendants: false })
  iconContentChildren?: QueryList<SummaryCardIconDirective>;

  @ContentChildren(SummaryCardFlagsDirective, { descendants: false })
  flagsContentChildren?: QueryList<SummaryCardFlagsDirective>;

  @ContentChildren(SummaryCardActionsDirective, { descendants: false })
  actionsContentChildren?: QueryList<SummaryCardActionsDirective>;

  @ContentChildren(SummaryCardBodyDirective, { descendants: false })
  bodyContentChildren?: QueryList<SummaryCardBodyDirective>;

  public onCardClick(event: Event): void {
    if (!this.isClickable) {
      return;
    }

    this.onClick.emit(event);
  }

  public get showContextMenu(): boolean {
    return !!this.link.length;
  }

  public get hasIcon(): boolean {
    return !!this.iconContentChildren?.length;
  }

  public get hasFlags(): boolean {
    return !!this.flagsContentChildren?.find(c => c.hasChildren);
  }

  public get hasActions(): boolean {
    return !!this.actionsContentChildren?.find(c => c.hasChildren);
  }

  public get hasBody(): boolean {
    return !!this.bodyContentChildren?.length;
  }
}
